import { LOAD_CURRENT_USER } from "../actions/user";

const DEFAULT_STATE = {};

const currentUser = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case LOAD_CURRENT_USER:
      return action.currentUser;
    default:
      return state;
  }
};

export default currentUser;
